/**
 * Resolve the station key used by the transfer animation pipeline, inventory
 * holds, and OHT runtime snapshots — must stay consistent across socket ingest,
 * scheduler arming, and 3D animation completion callbacks.
 */
export function resolveTransferStationId(input: {
  stockerId?: string | null;
  toolId?: string | null;
  portId?: string | null;
}): string {
  const stockerId = typeof input.stockerId === 'string' ? input.stockerId.trim() : '';
  if (stockerId) return stockerId;
  const toolId = typeof input.toolId === 'string' ? input.toolId.trim() : '';
  if (toolId) return toolId;
  const portId = typeof input.portId === 'string' ? input.portId.trim() : '';
  const match = portId.match(/^((?:ST|STOCKER)[-_][A-Za-z0-9]+)(?=[-_]LP|$)/i);
  return match?.[1] ?? '';
}

export function isStockerPortId(portId: string | null | undefined): boolean {
  if (!portId) return false;
  return /^(?:ST|STOCKER)[-_]/i.test(portId.trim());
}
